/**
 * LanguageMultiSelect — MultiSelect preconfigured with the ISO 639-1 language
 * list, matching the "Select languages" field already used in the campaign
 * editor (editor.tsx), so every "Language" filter in the app shares one look.
 */

import MultiSelect, { type MultiSelectOption } from '@/components/MultiSelect';
import { LANGUAGE_ISO } from '@/lib/constants/languageIso';

const LANGUAGE_OPTIONS: MultiSelectOption[] = LANGUAGE_ISO.map((l) => ({
  value: l.value,
  label: `${l.text} (${l.value})`,
}));

export interface LanguageMultiSelectProps {
  value: string[];
  onChange: (values: string[]) => void;
  placeholder?: string;
  className?: string;
  portalled?: boolean;
}

export default function LanguageMultiSelect({
  value,
  onChange,
  placeholder,
  className,
  portalled,
}: LanguageMultiSelectProps) {
  return (
    <MultiSelect
      options={LANGUAGE_OPTIONS}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      className={className}
      portalled={portalled}
    />
  );
}
